module.exports = __webpack_public_path__ + "static/media/horizontal-bat-msg.5fc0adb8.svg";